import React, { useContext, useEffect, useState, useMemo } from 'react';
import { HashRouter, Route, Switch, Link, Redirect } from 'react-router-dom';
import { observer } from 'mobx-react';
import userAuthStore from '../store/user';
import zhCN from 'antd/es/locale/zh_CN';
import { ConfigProvider, Result } from 'antd';
import RouteConfig from './config';
const Router = observer(() => {
  const user = useContext(userAuthStore);
  useEffect(() => {
    user.getAuth();
  }, []);

  // 选择第一个

  const renderRouteDom = (list: any[]) => {
    return list.map((item) => {
      return (
        <Route
          key={item.path}
          path={item.path}
          exact={item.exact}
          render={(props) => {
            if (item.children) {
              if (item.code && !user.authdata[item.code.toLocaleUpperCase()]&& !user.authdata[item.code.toLocaleLowerCase()]) {
                return (
                  <Result
                    style={{ background: '#fff' }}
                    icon={<img src={require('./403.png')} width='665px' />}
                    subTitle='您暂无公众号管家管理权限，请联系分校管理员开通权限'
                  />
                );
              }
              if (!item.component) {
                return renderRouteDom(item.children);
              }
  
              return (
                <item.component {...props}>
                  {renderRouteDom(item.children)}
                </item.component>
              );
            }
            if (item.code && !user.authdata[item.code.toLocaleUpperCase()]&& !user.authdata[item.code.toLocaleLowerCase()]) {
              return (
                <Result
                  style={{ background: '#fff' }}
                  icon={<img src={require('./403.png')} width='665px' />}
                  subTitle='您暂无公众号管家管理权限，请联系分校管理员开通权限'
                />
              );
            }
            return <item.component {...props} />;
          }}
        />
      );
    });
  };
  const renderRoute = useMemo(() => {
    return renderRouteDom(RouteConfig);
  }, [RouteConfig]);
  return (
    <HashRouter>
      <ConfigProvider locale={zhCN}>
        <Route exact path='/'>
          <Redirect to='/home'/>
        </Route>
        {user.authdata != null && <Switch>{renderRoute}</Switch>}
      </ConfigProvider>
    </HashRouter>
  );
});
export default Router;
